// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Constant
import { USER_ACCESS_MODULE, USER_ACCESS_URL } from 'constant/url.constant'
import { ACCESS_CODE_USER_ACCESS } from 'constant/access.constant'

// QA Index Router
import { userAccessIndexRoutes } from './user-access.router'

const userAccessRoutes: IRouteParent = {
  path: USER_ACCESS_URL.INDEX,
  meta: {
    attrs: {
      module: USER_ACCESS_MODULE,
      icon: 'back-office/icon-user-access',
      label: 'backOffice.userAccess',
      accessCodes: ACCESS_CODE_USER_ACCESS,
    },
  },
  children: [...userAccessIndexRoutes],
}

export { userAccessRoutes }
